import { EthernalFireEffect } from 'game/extended/heros/mage/ethernal_fire/ethernal_fire_effect'

export default {
    events: {},
    effects: {
        EthernalFireEffect
    },
    requirements: {}
}